
    // let url  = 'http://121.5.221.142:5000'
// let url  = 'https://hkjy-api.hikoon.com'
// let url = "http://hkjy.api"
export default process.env.VUE_APP_API_URL
// export default 'https://hkjy-test-api.hikoon.com'